/**
 * External Imports
 */
import { FC } from 'react';

/**
 * Nexus Imports
 */
import { NeuButton, NeuIcon } from '@neutron/react';

/**
 * Style Imports
 */
import './BasicToast.styles';

const BasicToast: FC<{
  msg: string;
  feedback: 'info' | 'success' | 'error' | 'warning' | 'none';
  confirmText?: string | null;
  confirm?: () => void;
}> = ({ msg, feedback, confirmText, confirm }) => (
  <>
    <span
      className={`d-flex flex-row align-items-center justify-content-evenly w-100 mb-${
        feedback !== 'info' ? '0' : '2'
      } ${feedback === 'info' ? 'toast-small-text' : ''}`}
    >
      {feedback !== 'none' && (
        <NeuIcon
          color={
            feedback === 'info'
              ? 'blue'
              : feedback === 'success'
              ? 'green'
              : feedback === 'warning'
              ? 'orange'
              : 'red'
          }
        >
          {feedback === 'info'
            ? 'info'
            : feedback === 'success'
            ? 'check_circle'
            : feedback === 'warning'
            ? 'warning'
            : 'error'}
        </NeuIcon>
      )}
      {msg}
    </span>
    {confirmText && confirm && (
      <div className="d-flex flex-row justify-content-center mt-2">
        <NeuButton
          color="red"
          kind="primary"
          size="small"
          onClick={() => confirm()}
        >
          {confirmText}
        </NeuButton>
      </div>
    )}
  </>
);
export default BasicToast;
